import React from 'react'

const SubmitButton: React.FC<{ isSubmitting: boolean; text: string }> = ({ isSubmitting, text }) => (
    <button
        type="submit"
        disabled={isSubmitting}
        className={`px-6 py-2.5 text-sm font-medium text-white bg-black rounded-lg focus:ring-4 focus:ring-primary-200 hover:bg-primary-800 transition ${
          isSubmitting ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        {isSubmitting ? (
          <span className="flex items-center justify-center">
            <svg
              className="animate-spin h-4 w-4 mr-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              ></path>
            </svg>
            Submitting...
          </span>
        ) : (
          text
        )}
      </button>
  );
  
  export default SubmitButton;